var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pdfTemplate", {
        ref: "pdfTemplate",
        attrs: { data: _vm.data },
        on: {
          close: _vm.handleClose,
          getPONo: _vm.getPONo,
          refresh: _vm.getData,
        },
      }),
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c("BjDivider", [
            _vm._v(
              " " + _vm._s(_vm.$t("BusinessPurchaseOrder3.Warehouse")) + " "
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.data.purchaseOrderReceives,
                border: "",
                script: "",
                "max-height": "600",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("table.countText"),
                  type: "index",
                  align: "center",
                  "min-width": 60,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.Date"),
                  prop: "creationDate",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(_vm._s(_vm._f("timeFilters")(row.creationDate))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder2.Unit"),
                  prop: "shippingMethod",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.ContainerId"),
                  prop: "actualContainerNo",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.Size"),
                  prop: "containerLength",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.Type"),
                  prop: "containerType",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalPalletQty",
                  label: _vm.$t("BusinessPurchaseOrder3.Total"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "csgPallet",
                  label: _vm.$t("BusinessPurchaseOrder3.Hire"),
                  align: "center",
                },
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: _vm.$t("BusinessPurchaseOrder3.CustomerPalletQty"),
                    align: "center",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "standardPallet",
                      label: _vm.$t("BusinessPurchaseOrder3.Standard"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "chepPallet",
                      label: _vm.$t("BusinessPurchaseOrder3.Chep"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "loscomPallet",
                      label: _vm.$t("BusinessPurchaseOrder3.Loscom"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "nonStandardPallet",
                      label: _vm.$t("BusinessPurchaseOrder3.nonStandard"),
                      align: "center",
                    },
                  }),
                ],
                1
              ),
              _c("el-table-column", {
                attrs: {
                  prop: "cartonQty",
                  label: _vm.$t("BusinessPurchaseOrder3.cartonQty"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "labourTime",
                  label: _vm.$t("BusinessPurchaseOrder3.Extra"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "comments",
                  label: _vm.$t("BusinessPurchaseOrder3.comments"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdName",
                  label: _vm.$t("BusinessPurchaseOrder3.Submitter"),
                  align: "center",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }